import { render } from "./CertificateEditModal.vue?vue&type=template&id=87df7bcc&ts=true"
import script from "./CertificateEditModal.vue?vue&type=script&lang=ts"
export * from "./CertificateEditModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__